
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/docs/start-here/core-technology-discussions/initial-dex-offering",
      function () {
        return require("private-next-pages/docs/start-here/core-technology-discussions/initial-dex-offering/index.mdx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/docs/start-here/core-technology-discussions/initial-dex-offering"])
      });
    }
  